import { Component } from 'react'
import PropTypes from 'prop-types'
import withNotifications from 'components/shared/notifications'
import ConditionalRender from 'components/shared/ConditionalRender'
import MarketoActivityOption from './MarketoActivityOption'
import { DriftActivityType, EmptyActivity } from './constants'
import AddButton from 'components/Integration/components/AddButton/index'
import {
  fetchMarketoMappedActivities,
  deleteMarketoMappedActivity,
  patchMarketoMappedActivities
} from 'app/modules/integrations/api'

import {
  values, isNil, merge, findIndex, propEq, isEmpty,
  update, append, all, complement, reject, addIndex, equals
} from 'ramda'

import marketoEmptyActivityState from 'images/svg/marketo-empty-activity.svg'

const ERROR_MESSAGE = "Ooops, something went wrong. Please try again."
const indexMatches = (indexToMatch) => (value, index) => index === indexToMatch

const isMappedActivityFullyDefined = activity =>
  all(complement(isNil))([
    activity.marketoName,
    activity.marketoId,
    activity.activityType
  ])


class MarketoActivityMapper extends Component {

  state = {
    activities: []
  }

  componentDidMount() {
    const handleActivities = (activities) => {
      this.setState({ activities })
    }

    fetchMarketoMappedActivities()
      .then(handleActivities)
  }

  addActivity = () => {
    const { activities } = this.state
    const updatedActivities = append(EmptyActivity, activities)
    this.setState({ activities: updatedActivities })
  }

  tryDeleteActivity = (mappedActivity, oldActivities) => {
    const { notifications } = this.props
    if (!mappedActivity.activityType) return

    const handleError = () => {
      this.setState({ activities: oldActivities })
      notifications.error(ERROR_MESSAGE)
    }

    deleteMarketoMappedActivity(mappedActivity.activityType)
      .catch(handleError)
  }

  deleteActivity = ({ activityIndex, mappedActivity }) => {
    const { activities } = this.state
    const updatedActivities = addIndex(reject)(indexMatches(activityIndex), activities)
    const onLocalStateUpdated = () => this.tryDeleteActivity(mappedActivity, activities)

    this.setState({ activities: updatedActivities }, onLocalStateUpdated)
  }

  tryPatchActivities = (oldActivities, newActivities) => {
    const { notifications } = this.props
    const fullyDefinedActivities = newActivities.filter(isMappedActivityFullyDefined)
    if (isEmpty(fullyDefinedActivities)) return

    const handleError = () => {
      this.setState({ activities: oldActivities })
      notifications.error(ERROR_MESSAGE)
    }

    return patchMarketoMappedActivities(fullyDefinedActivities)
      .catch(handleError)
  }

  tryHandlingDriftActivityTypeChange = ({ activityIndex, mappedActivity }) => {
    const { activities } = this.state
    const existingActivity = activities[activityIndex]

    const wasActivityTypeChanged = existingActivity &&
      existingActivity.activityType &&
      existingActivity.activityType !== mappedActivity.activityType

    if (wasActivityTypeChanged) {
      deleteMarketoMappedActivity(existingActivity.activityType)
    }
  }

  updateActivities = ({ activityIndex, mappedActivity }) => {
    const { activities } = this.state
    const updatedActivity = merge(activities[activityIndex], mappedActivity)
    const updatedActivities = update(activityIndex, updatedActivity, activities)
    const onLocalStateUpdated = () => this.tryPatchActivities(activities, updatedActivities)

    this.tryHandlingDriftActivityTypeChange({ activityIndex, mappedActivity })
    this.setState({ activities: updatedActivities }, onLocalStateUpdated)
  }

  render() {
    const { activities } = this.state
    const isAddActivityDisabled = activities.length >= values(DriftActivityType).length

    return (
        <div>
          <div className="marketo-activity-mapper">
            <div className="marketo-activity-mapper-header">
              <div>
                Drift Activity
              </div>
              <div>
                Marketo Activity
              </div>
            </div>
            <ConditionalRender condition={isEmpty(activities)}>
              <div className="marketo-activity-mapper-empty-state">
                <img src={marketoEmptyActivityState}/>
                <p>You don’t have any activity mapped between Drift and Marketo yet.</p>
              </div>
            </ConditionalRender>
            <ConditionalRender condition={!isEmpty(activities)}>
              <div className="marketo-activity-mapper-actions">
                {activities.map((activity, index) =>
                  <MarketoActivityOption
                    key={index}
                    activityIndex={index}
                    activity={activity}
                    mappedActivities={activities}
                    updateActivities={this.updateActivities}
                    deleteActivity={this.deleteActivity}
                  />
                )}
              </div>
            </ConditionalRender>
          </div>
          <div className="marketo-activity-mapper-footer">
            <AddButton
              className="add-drift-activity-button"
              addButtonLabel="Add Drift Activity"
              type="tertiary"
              onClick={this.addActivity}
            />
          </div>
        </div>
    )
  }
}

export default withNotifications(MarketoActivityMapper)


// WEBPACK FOOTER //
// ./src/scripts/components/Integration/pages/MarketoIntegrationPage/MarketoActivityMapper.js